<template>
  <div class="gl-equalizer-loader">
    <div
      v-for="(filled, index) in bars"
      :key="index"
      class="bar"
      :class="{ filled }"
    />
  </div>
</template>

<script>
export default {
  name: 'GlEqualizerLoader',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    totalBars: {
      type: Number,
      default: 40,
    },
  },
  data() {
    return {
      bars: [],
    }
  },
  watch: {
    value(val) {
      this.updateBars(val)
    },
  },
  mounted() {
    this.bars = new Array(this.totalBars).fill(false)
    this.updateBars(this.value)
  },
  methods: {
    updateBars(val) {
      const value = Math.max(0, Math.min(Number(val), 100))
      const targetCount = Math.round((value / 100) * this.totalBars)

      this.bars.forEach((_, i) => {
        if (i < targetCount && !this.bars[i]) {
          setTimeout(() => {
            this.$set(this.bars, i, true)
          }, i * 10)
        }

        if (i >= targetCount && this.bars[i]) {
          setTimeout(() => {
            this.$set(this.bars, i, false)
          }, (this.totalBars - i) * 10)
        }
      })
    },
  },
}
</script>

<style scoped>
.gl-equalizer-loader {
  display: flex;
  gap: 2px;
  height: 24px;
  width: 100%;
}

.bar {
  flex: 1;
  border-radius: 2px;
  background-color: rgba(9, 21, 64, 0.08);
  transition: all .2s ease;
  scale: .95;
}

.bar.filled {
  background-color: var(--Brand-Main, #194BFB);
  scale: 1;
}
</style>
